import { FC, memo, useMemo } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { QuickHelp } from 'components/quick-help'
import Warning from 'modules/warning'

import { Navbar } from '../navbar'

import { LayoutProps } from './layout.model'
import * as S from './styles'

const Footer = dynamic(() => import('../footer'), { ssr: true })
const Quicklinks = dynamic(() => import('../quicklinks'), { ssr: true })

export const Layout: FC<LayoutProps> = memo(({ hasCTA = false, darkWarning = false, children }) => {
  const { pathname } = useRouter()
  const disableList = useMemo(
    () => [
      '/condo',
      '/condo/indica',
      '/emprestimo-com-garantia-de-imovel',
      '/emprestimo-com-garantia-de-terreno',
      '/emprestimo-online',
      '/emprestimo-para-capital-de-giro',
      '/emprestimo-para-reforma',
      '/emprestimo-para-empresa',
      '/fale-conosco',
      '/financiamento-energia-solar',
      '/financiamento-imobiliario',
      '/home-equity',
      '/portabilidade-de-dividas',
      '/programa-de-integridade',
      '/quem-somos',
      '/simulacao-de-emprestimo',
      '/relacoes-com-investidores',
      '/sou-cliente',
      '/seja-um-parceiro',
      '/bacen',
      '/validacao-dados-cadastrais'
    ],
    []
  )

  return (
    <S.Container {...{ $hascta: hasCTA }}>
      <S.TopHeader>
        <Navbar />
        <Warning $darkMode={darkWarning} />
        {!disableList.includes(pathname) && <QuickHelp />}
      </S.TopHeader>
      {children}
      <Quicklinks />
      <Footer />
    </S.Container>
  )
})

Layout.displayName = 'Layout'
